"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelValueDescription = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const MarkupStyles_1 = require("../../style/MarkupStyles");
const LabelHelpTooltips_1 = require("../help/LabelHelpTooltips");
const LabelManagement_1 = require("../LabelManagement");
function LabelValueDescription({ showLink, disabled, description }) {
    return (react_1.default.createElement(LabelHelpTooltips_1.HelpTextDiv, { disabled: disabled },
        react_1.default.createElement("div", { style: { paddingTop: '8px' } },
            react_1.default.createElement(MarkupStyles_1.FormattedMarkupWrapperInTooltip, { markup: description !== null && description !== void 0 ? description : '' }),
            showLink && description
                ? (react_1.default.createElement("span", { style: { margin: '0 3px' } },
                    react_1.default.createElement(LabelManagement_1.LabelManagementLink, null)))
                : null)));
}
exports.LabelValueDescription = LabelValueDescription;
//# sourceMappingURL=LabelValueDescription.js.map